import lodash from "lodash";
import { util } from "../../lib/util/util";
import { FakeLodash } from "../../lib/coreutil/FakeLodash";
export var CelticKnots;
(function (CelticKnots) {
    let Element;
    (function (Element) {
        function maybeEqual(a, b) {
            if (!a || !b)
                debugger;
            if (a.type == "is" && b.type == "is")
                return a.value == b.value;
            if (a.type == "is" && b.type == "isnot")
                return a.value != b.value;
            if (a.type == "isnot" && b.type == "is")
                return a.value != b.value;
            if (a.type == "isnot" && b.type == "isnot")
                return true;
        }
        Element.maybeEqual = maybeEqual;
        function toString(e) {
            switch (e.type) {
                case "is":
                    return e.value.toString();
                case "isnot":
                    return `!${e.value}`;
            }
        }
        Element.toString = toString;
    })(Element = CelticKnots.Element || (CelticKnots.Element = {}));
    let Snake;
    (function (Snake) {
        function rotate(snake, move) {
            return snake.map((_, i) => snake[(i - move + snake.length) % snake.length]);
        }
        Snake.rotate = rotate;
        function index(snake, index) {
            return snake[(index + snake.length) % snake.length];
        }
        Snake.index = index;
        function optimizeMove(snake, move) {
            const positive = (move + snake.length) % snake.length;
            const half = Math.floor(snake.length / 2);
            if (positive > half)
                return positive - snake.length;
            else
                return positive;
        }
        Snake.optimizeMove = optimizeMove;
        function toString(snake) {
            return snake.map(Element.toString).join(", ");
        }
        Snake.toString = toString;
    })(Snake = CelticKnots.Snake || (CelticKnots.Snake = {}));
    let PuzzleShape;
    (function (PuzzleShape) {
        var natural_order = util.Order.natural_order;
        function isEqual(a, b) {
            return lodash.isEqual(a.snake_lengths, b.snake_lengths) && a.locks.length == b.locks.length;
        }
        PuzzleShape.isEqual = isEqual;
        function hash(shape) {
            return [...shape.snake_lengths, ...shape.locks.map(lock => {
                    const [min, max] = lock.first.snake < lock.second.snake
                        ? [lock.first, lock.second]
                        : [lock.second, lock.first];
                    return 10000 * (min.snake * 100 + min.tile) + (max.snake * 100 + max.tile);
                }).sort(natural_order)];
        }
        PuzzleShape.hash = hash;
    })(PuzzleShape = CelticKnots.PuzzleShape || (CelticKnots.PuzzleShape = {}));
    let PuzzleState;
    (function (PuzzleState) {
        function generate(shape) {
            const state = {
                shape: shape,
                snakes: shape.snake_lengths.map(s => new Array(s).fill(0).map(() => ({ value: lodash.random(20), type: "is" })))
            };
            shape.locks.forEach(({ first, second }) => {
                state.snakes[second.snake][second.tile] = state.snakes[first.snake][first.tile];
            });
            return state;
        }
        PuzzleState.generate = generate;
        function shuffle(state) {
            return {
                shape: state.shape,
                snakes: state.snakes.map(snake => {
                    const o = lodash.random(snake.length);
                    return Snake.rotate(snake, o);
                })
            };
        }
        PuzzleState.shuffle = shuffle;
        function get(state, index) {
            return state.snakes[index.snake][index.tile];
        }
        PuzzleState.get = get;
        function isSolved(state) {
            return state.shape.locks.every((lock) => lockMaybeSolved(state, lock));
        }
        PuzzleState.isSolved = isSolved;
        function doMove(state, ...moves) {
            return {
                snakes: state.snakes.map((snake, index) => {
                    const move = moves.find(m => m.snake_index == index);
                    if (move)
                        return Snake.rotate(snake, move.offset);
                    else
                        return snake;
                }),
                shape: state.shape
            };
        }
        PuzzleState.doMove = doMove;
        function lockMaybeSolved(state, lock) {
            const a = get(state, lock.first);
            const b = get(state, lock.second);
            return Element.maybeEqual(a, b);
        }
        PuzzleState.lockMaybeSolved = lockMaybeSolved;
        function equal(a, b) {
            return lodash.isEqual(a, b);
        }
        PuzzleState.equal = equal;
    })(PuzzleState = CelticKnots.PuzzleState || (CelticKnots.PuzzleState = {}));
    function construct(shape, snakes) {
        return {
            shape: shape,
            snakes: snakes.map(s => s.map(t => ({ type: "is", value: t })))
        };
    }
    CelticKnots.construct = construct;
    let Solution;
    (function (Solution) {
        function equals(a, b) {
            return lodash.isEqual(a, b);
        }
        Solution.equals = equals;
        function toString(a) {
            return a.moves.map(m => `${m.snake_index}:${m.offset}`).join(",");
        }
        Solution.toString = toString;
    })(Solution = CelticKnots.Solution || (CelticKnots.Solution = {}));
    function unify(a, b) {
        if (!a || !b)
            return null;
        if (!PuzzleShape.isEqual(a.shape, b.shape)) {
            return null;
        }
        function unifyElement(a, b) {
            if (a.type == "is" && b.type == "is" && a.value == b.value)
                return a;
            else if (a.type == "is" && b.type == "isnot" && a.value != b.value)
                return a;
            else if (a.type == "isnot" && b.type == "is" && a.value != b.value)
                return b;
            else if (a.type == "isnot" && b.type == "isnot")
                return b;
            else
                return null;
        }
        function unifyLane(a, b) {
            const res = [];
            for (let i = 0; i < a.length; i++) {
                const el = unifyElement(a[i], b[i]);
                if (!el)
                    return null;
                res.push(el);
            }
            return res;
        }
        function findLaneUnification(a, b) {
            for (let i = 0; i < a.length; i++) {
                const b_rotated = Snake.rotate(b, i);
                const res = unifyLane(a, b_rotated);
                if (res)
                    return res;
            }
            return null;
        }
        const lanes = [];
        for (let i = 0; i < a.snakes.length; i++) {
            const unified_lane = findLaneUnification(a.snakes[i], b.snakes[i]);
            if (!unified_lane)
                return null;
            lanes.push(unified_lane);
        }
        return {
            shape: a.shape,
            snakes: lanes
        };
    }
    CelticKnots.unify = unify;
    function solveAll(state) {
        // Solve every lock individually.
        // Use backtracking to find a combination of moves that solves all locks
        function backtracking(next_lock_index, state, commited_moves) {
            if (next_lock_index >= state.shape.locks.length) {
                if (!PuzzleState.isSolved(state))
                    debugger;
                // All locks are solved, return solution
                return [{
                        end_state: state,
                        moves: commited_moves.map((e, i) => e ?? { snake_index: i, offset: 0 })
                    }];
            }
            function recurseWith(move, solved) {
                commited_moves[move.snake_index] = move;
                const res = backtracking(next_lock_index + (solved ? 1 : 0), PuzzleState.doMove(state, move), commited_moves);
                commited_moves[move.snake_index] = null;
                return res;
            }
            const lock = state.shape.locks[next_lock_index];
            if (commited_moves[lock.first.snake] == null && commited_moves[lock.second.snake] == null) {
                // Both snakes have no attached move yet. Just check all moves for one of them
                const moving_snake = state.snakes[lock.first.snake];
                return moving_snake.map((e, index) => {
                    return { snake_index: lock.first.snake, offset: Snake.optimizeMove(moving_snake, index) };
                }).flatMap(m => recurseWith(m, false));
            }
            else if (commited_moves[lock.first.snake] == null || commited_moves[lock.second.snake] == null) {
                const [lock_on_locked_snake, lock_on_free_snake] = commited_moves[lock.first.snake]
                    ? [lock.first, lock.second]
                    : [lock.second, lock.first];
                const expected = state.snakes[lock_on_locked_snake.snake][lock_on_locked_snake.tile];
                const moving_snake = state.snakes[lock_on_free_snake.snake];
                return moving_snake.flatMap((e, index) => {
                    if (Element.maybeEqual(e, expected))
                        return recurseWith({ snake_index: lock_on_free_snake.snake, offset: Snake.optimizeMove(moving_snake, lock_on_free_snake.tile - index) }, true);
                    else
                        return [];
                });
            }
            else if (PuzzleState.lockMaybeSolved(state, lock)) {
                // If the lock is already solved, we can just continue with the next one without applying any move
                return backtracking(next_lock_index + 1, state, commited_moves);
            }
            else {
                // Both snakes are locked in but the lock is not solved. No possible solutions
                return [];
            }
        }
        const solutions = backtracking(0, state, state.snakes.map(() => null));
        const real_solutions = [];
        const maybe_solutions = [];
        solutions.forEach(s => {
            if (s.end_state.shape.locks.every(lock => s.end_state.snakes[lock.first.snake][lock.first.tile].type != "isnot" &&
                s.end_state.snakes[lock.second.snake][lock.second.tile].type != "isnot")) {
                real_solutions.push(s);
            }
            else {
                maybe_solutions.push(s);
            }
        });
        const preferred = FakeLodash.minBy(real_solutions, s => FakeLodash.sum(s.moves.map(m => Math.abs(m.offset)))) ?? (maybe_solutions.length == 1 ? maybe_solutions[0] : undefined);
        return { real: real_solutions, maybe: maybe_solutions, preferred: preferred };
    }
    CelticKnots.solveAll = solveAll;
    function solve(state) {
        return solveAll(state).preferred;
    }
    CelticKnots.solve = solve;
})(CelticKnots || (CelticKnots = {}));
